import { BACKEND_URL_PREFIX } from "../utils/const";
import {
  NETWORK_REQUEST_SENT,
  UMK_FETCH_COMPLETED,
  DISCIPLINE_LIST_FETCH_COMPLETED,
  UMK_FETCH_STARTED,
  FETCH_CIRRICULUM_START,
  FETCH_CIRRICULUM_COMPLETED,
  FETCH_CIRRICULUM_FAILED,
  FETCH_DISCIPLINES_START,
  FETCH_DISCIPLINES_COMPLETED,
  FETCH_DISCIPLINES_FAILED,
  FETCH_UMK_START,
  FETCH_UMK_COMPLETED,
  FETCH_UMK_FAILED,
  FETCH_UMK_CARD_START,
  FETCH_UMK_CARD_COMPLETED,
  FETCH_UMK_CARD_FAILED,
  FETCH_UMKLIST_DATA_STARTED,
  FETCH_UMKLIST_DATA_COMPLETED,
  CLEAR_UMK_DATA
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";

export const course = (id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      // из-за 500 ошибки (null)
      `${BACKEND_URL_PREFIX}/umk/course/${id !== null ? id : 2}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: DISCIPLINE_LIST_FETCH_COMPLETED, disciplineList: data });
    }
  }
};

export const umk = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: UMK_FETCH_STARTED });
    // ЗАГЛУШКА т.к. не приходит в объекте нужный ключ
    const gid = getState().auth.gid !== null ? getState().auth.gid : 1;
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/group/${gid}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: UMK_FETCH_COMPLETED, umk: data.group[0] });
      const a = getState().umk.group.educationPlanId;
      dispatch(course(a));
    }
  }
};

// Оригинальная версия для обратной совместимости
export const fetchCirriculum = (syid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: FETCH_CIRRICULUM_START });
    const response = await fetch(
      syid ?
        `${BACKEND_URL_PREFIX}/curriculum/${syid}/0` : `${BACKEND_URL_PREFIX}/curriculum/0/0`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: FETCH_CIRRICULUM_COMPLETED, payload: data });
    } else {
      await dispatch({ type: FETCH_CIRRICULUM_FAILED, error: response.error });
    }
  }
};


export const fetchCirriculumForUmk = (xp_key = 0, idcathedra = 0, idmetacourse = 0) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: FETCH_CIRRICULUM_START });
    const params = new URLSearchParams({
      xp_key: xp_key || 0,
      idcathedra: idcathedra || 0,
      idmetacourse: idmetacourse || 0
    });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/umk_teacher/curriculum?${params.toString()}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      // Новый API возвращает { cname, idcurriculum }, нужно преобразовать в формат, ожидаемый reducer
      const transformedData = data.map(item => ({
        idcurriculum: item.idcurriculum,
        'Название': item.cname
      }));
      await dispatch({ type: FETCH_CIRRICULUM_COMPLETED, payload: transformedData });
    } else {
      await dispatch({ type: FETCH_CIRRICULUM_FAILED, error: response.error });
    }
  }
};

export const fetchDisciplines = (filters) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const urlParams = new URLSearchParams(filters).toString();
    dispatch({ type: FETCH_DISCIPLINES_START });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/course/filters?${urlParams}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: FETCH_DISCIPLINES_COMPLETED, payload: data });
    } else {
      await dispatch({ type: FETCH_DISCIPLINES_FAILED, error: response.error });
    }
  }
};

export const fetchUmk = (idcurriculum, cid, onlySchedule = false) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());

  const params = onlySchedule ? { only_schedule: 1 } : {}
  const urlParams = new URLSearchParams(params).toString()
  if (getState().auth.token && idcurriculum != 0) {
    dispatch({ type: FETCH_UMK_START });
    const response = await fetch(
      urlParams.length != 0 ?
        `${BACKEND_URL_PREFIX}/umk/${cid}/${idcurriculum}?${urlParams}` :
        `${BACKEND_URL_PREFIX}/umk/${cid}/${idcurriculum}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: FETCH_UMK_COMPLETED, payload: data });
    } else {
      await dispatch({ type: FETCH_UMK_FAILED, error: response.error });
    }
  }
  if (getState().auth.token && cid == 0 && idcurriculum == 0) {
    dispatch({ type: FETCH_UMK_START });
    const response = await fetch(
      // TODO не работает корректно 404
      // `${BACKEND_URL_PREFIX}/umk/${999}/${999}?${urlParams}`,
      `${BACKEND_URL_PREFIX}/umk/${0}/${0}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: FETCH_UMK_COMPLETED, payload: data });
    } else {
      await dispatch({ type: FETCH_UMK_FAILED, error: response.error });
    }
  }
};

export const fetchUmkCard = (cid) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({ type: FETCH_UMK_CARD_START });
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/umk/${cid}`,
      buildDefaultHeaders(getState)
    );
    dispatch({ type: NETWORK_REQUEST_SENT, response });
    if (response.ok) {
      const data = await response.json();
      await dispatch({ type: FETCH_UMK_CARD_COMPLETED, payload: data });
    } else {
      await dispatch({ type: FETCH_UMK_CARD_FAILED, error: response.error });
    }
  }
};

export const fetchListData = (umkId, listId, idCurCourse) => async (dispatch, getState) => {
  if (listId) {
    dispatch({ type: FETCH_UMKLIST_DATA_STARTED });
    const response = await fetch(
      typeof listId === "number"
        ? `${BACKEND_URL_PREFIX}/umk/${umkId}/links/${listId}`
        : idCurCourse
          ? `${BACKEND_URL_PREFIX}/umk/${umkId}/${listId}/${idCurCourse}`
          : `${BACKEND_URL_PREFIX}/umk/${umkId}/${listId}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      await dispatch({
        type: FETCH_UMKLIST_DATA_COMPLETED,
        payload: data,
        typeData: typeof listId === "number" ? false : listId,
      });
    }
  }
};

export const clearUmkData = () => (dispatch) => {
  dispatch({ type: CLEAR_UMK_DATA });
};
